import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DropDownComponent } from '../ui/components/drop-down/drop-down.component';
import { TextFieldComponent } from '../ui/components/text-field/text-field.component';
import { TextAreaComponent } from '../ui/components/text-area/text-area.component';
import { FileUploadComponent } from '../ui/components/file-upload/file-upload.component';
import { RadioButtonComponent } from '../ui/components/radio-button/radio-button.component';
import { PrivatePersonComponent } from './pages/private-person/private-person.component';
import { PersonalComponent } from './components/private-person/personal/personal.component';
import { FamilyComponent } from './components/private-person/family/family.component';
import { IncomesComponent } from './components/private-person/incomes/incomes.component';
import { ApplicationComponent } from './components/application/application.component';
import { AttachmentsComponent } from './components/private-person/attachments/attachments.component';
import { OrganizationComponent } from './pages/organization/organization.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { DetailsComponent } from './components/organization/details/details.component';
import { ContactComponent } from './components/organization/contact/contact.component';
import { AdditionalComponent } from './components/organization/additional/additional.component';
import { UiModule } from '../ui/ui.module';

@NgModule({
  declarations: [
    DropDownComponent,
    TextFieldComponent,
    TextAreaComponent,
    // FileUploadComponent,
    RadioButtonComponent,
    PrivatePersonComponent,
    PersonalComponent,
    FamilyComponent,
    IncomesComponent,
    ApplicationComponent,
    AttachmentsComponent,
    ConfirmationComponent,
    OrganizationComponent,
    DetailsComponent,
    ContactComponent,
    AdditionalComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
    RouterModule.forChild([
      { path: 'privatperson', component: PrivatePersonComponent },
      { path: 'organisation', component: OrganizationComponent },
      { path: 'inskickad', component: ConfirmationComponent },
    ]),
  ],
  exports: [RouterModule],
  providers: [],
})
export class PublicModule {}
